export default __webpack_public_path__ + "static/English Proficiency Requirements-6a95a164951bf4fbdb5fee3138893a48.pdf";